import React, { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom"
import { Form, Input } from "antd";
import style from "./props.module.sass";
import { findIdSelector } from "../reduxSelector";
import { updateFormProperties } from "../../../../../../stateManager/store/formCreation/action";
import _ from "lodash";

const AssetPropertiesPanel = (props: any) => {
  const dispatch = useDispatch()
  const params: any = useParams();
  const { json = {}, canEdit } = props

  const {
    id: hId,
    assetId: id,
    elementId: elId,
    bind,
    isChildAsset,
    type,
    assetInstanceId: pAInstanceId,
  } = json.json || {}

  const assets = useSelector((state: any) => state.assets.list);
  const form = useSelector((state: any) => state.formcreation[params.formId]);
  const selectedAsset = assets[id] || {};

  const assetLabel =
    (selectedAsset &&
      selectedAsset.json &&
      selectedAsset.json.properties &&
      selectedAsset.json.properties.label) ||
    (selectedAsset.json && selectedAsset.json.label) ||
    selectedAsset.label

  const currentState: any = useSelector((state: any) => {
    return hId ? findIdSelector(state, params.formId, hId.split("#"), true) : [];
  });

  const { assetInstanceId, assetBindPrefix } = currentState || {};

  const aParent = getAssetField(form, id, pAInstanceId)

  const onChange = (data: any, key: string) => {
    if (canEdit) {
      const setData = _.setWith({}, key, data, Object);
      dispatch(
        updateFormProperties({
          formid: params.formId,
          id: hId,
          data: setData,
        })
      );
    }
  }

  return (
    <Fragment>
      <Form.Item label="Asset Id" className={'a8-form-item props'}>
        <Input className={style.borderRemove} value={id} disabled={true} />
      </Form.Item>

      <Form.Item label="Asset Label" className={'a8-form-item props'}>
        <Input className={style.borderRemove} value={assetLabel} disabled={true} />
      </Form.Item>

      <Form.Item label="Id" className={'a8-form-item props'}>
        <Input className={style.borderRemove} value={elId} disabled={true} />
      </Form.Item>

      {bind && (isChildAsset || (type !== "Container" && type !== "Section")) && (
        <Form.Item label="Bind" className={'a8-form-item props'}>
          <Input
            className={style.borderRemove}
            value={
              (bind && aParent && aParent.assetBindPrefix)
                ? bind.startsWith("${bindPrefix}")
                  ? bind.replace("${bindPrefix}", aParent.assetBindPrefix)
                  : bind
                : bind
            }
            disabled={true}
          />
        </Form.Item>
      )}

      {!isChildAsset && (
        <Form.Item label="Asset Instance Id" className={'a8-form-item props'}>
          <Input
            className={style.borderRemove}
            value={assetInstanceId}
            disabled={!canEdit}
            onChange={(e: any) => onChange(e.target.value, 'assetInstanceId')}
          />
        </Form.Item>
      )}

      {!isChildAsset && (
        <Form.Item label="Bind Prefix" className={'a8-form-item props'}>
          <Input
            className={style.borderRemove}
            value={assetBindPrefix}
            disabled={!canEdit}
            onChange={(e: any) => onChange(e.target.value, 'assetBindPrefix')}
          />
        </Form.Item>
      )}
    </Fragment>
  )
}

export default AssetPropertiesPanel

const getAssetField = (form: any[], assetId: string, assetInstanceId: string): any => {
  // eslint-disable-next-line
  const field = form.reduce((a, item) => {
    if (a) {
      return a
    }

    if (item.assetId === assetId && item.assetInstanceId === assetInstanceId) {
      return item
    }

    if (item.fields) {
      return getAssetField(item.fields, assetId, assetInstanceId);
    }
  }, null);

  return field;
}

